import styled from '@emotion/styled/macro';
import { colors, fonts } from '../../styles/theme';
import { Subtext } from '../../base/typography';
import { Icon } from '../../ui_elements/icons';
import { Button, LinkButton } from '../../form';

const borderStyle = `1px solid ${colors.grey.secondaryDark}`;

const AuthorName = styled(Subtext)`
  font-weight: 500;
  font-size: 15px;
  color: ${colors.black};
  margin-left: 50px;
`;

const ReplyName = styled(Subtext)`
  font-weight: 500;
  font-size: 15px;
  color: ${colors.black};
  margin-left: 40px;
`;

const FlexWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.grey.primary};
`;

const FlexContent = styled('div')`
  display: flex;
  align-items: center;
`;

const AvatarPresenter = styled('div')`
  padding: 11px 0;
`;

const EditLinkButton = styled('LinkedButton')`
  padding: 5px 0;
`;

const ResolveButton = styled(Button)`
  background: ${colors.white};
  border: 1px solid ${colors.grey.secondaryDark};
  color: ${colors.grey.primaryLight};
  font-size: ${fonts.sans.size.small};
  padding: 0 9px;
  line-height: 0;
  max-width: 78px;
  max-height: 30px;
  font-family: 'Gotham A', 'Gotham B', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  border-radius: 2px;
  &:hover {
    color: ${colors.grey.primary};
    cursor: pointer;
    text-decoration: none;
    background: ${colors.white};
  }
`;

const EditIcon = styled(Icon)`
  font-size: 13px;
  padding-left: 8px;
  font-weight: 500;
  color: ${colors.blue.primary};
  &:hover {
    color: ${colors.blue.primaryDark};
    cursor: pointer;
    text-decoration: none;
  }
`;

const CommentHeaderContainer = styled('div')`
  padding: 0 11px 0 17px;
`;

const CommentBodyContainer = styled('div')`
  padding: 0px 20px 0 18px;
`;

const CommentFormContainer = styled('div')`
  margin: 7px 0;
`;

const StyledLinkButton = styled(LinkButton)`
  line-height: 14px;
  height: auto;
`;

const CommentWrapper = styled('div')`
  width: ${(props) => (props.width ? props.width : '400px')};
  border: 1px solid ${colors.grey.secondaryDark};
  border-left: ${(props) => (props.borderLeft ? `3px solid ${colors.orange.primary}` : `1px solid ${colors.grey.secondaryDark}`)};
  border-radius: ${(props) => (props.showReplyForm ? `3px 3px 0 0` : `3px`)};
  cursor: ${(props) => !props.commentResolved && !props.showReplyForm && 'pointer'};
  background-color: #f8f8f8;
  background-color: ${(props) => props.commentResolved && '#ebebeb'};
  background-color: ${(props) => !props.commentResolved && props.showReplyForm === true && 'white'};
  &:hover {
    background-color: ${(props) => !props.commentResolved && !props.showReplyForm && '#fcfcfc'};
  }
`;

const CommentListContainer = styled('div')`
  border: ${props => props.isActive && !props.showReplyForm ? `3px solid orange` : `1px solid ` + colors.grey.secondaryDark };
  width: ${(props) => (props.width ? props.width : '400px')};
  border-radius: 3px;
  margin: 0;
  margin-bottom: ${(props) => props.border && `10px`};
  box-shadow: ${(props) => props.border && '0 1px 2px 0 #eee'}};
  -webkit-box-shadow: ${(props) => props.border && '0 1px 2px 0 #eee'}};
`;

const OpeningThreadContainer = styled('div')`
  padding: 0px;
  ${props => props.isActive && 'background-color: #fcfcfc;'}
`;

const FlexPresenter = styled('div')`
  padding: 11px 0;
  border-bottom: ${borderStyle};
  border-style: none none dashed none;
`;

const HighlightedTextContainer = styled('div')`
  margin: 0 20px 10px 0;
  font-family: ${fonts.sans.family};
`;

const StyledSubtext = styled(Subtext)`
  font-style: italic;
`;

const HighlightedText = styled('span')`
  background-color: ${colors.orange.lightest};
  border-bottom: 2px solid #ffa859;
  padding: 2px 2px 0 2px;
  margin-left: 10px;
`;

const BodyContainer = styled('div')`
  line-height: 28px;
  padding: 0 20px 22px 20px;
  word-break: break-word;
  font-family: 'Gotham A', 'Gotham B', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  a {
    color: #2563eb;
    text-decoration: underline;
  }
  p {
    margin: 0;
  }
`;

const ArticleIcon = styled(Icon)`
  margin-right: 5px;
  margin-bottom: 3px;
`;

const IndicatorButton = styled('div')`
  border: 0.75px solid #4aa2bf;
  color: #4aa2bf;
  background: white;
  min-width: 67px;
  text-align: center;
  margin-left: 5px;
  font-size: 10px;
  border-radius: 2px;
  line-height: 15px;
  letter-spacing: 0.05em;
  padding: 0 3px 0 4px;
  top: -1px;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-weight: 500;
`;

const MarkdownWrapper = styled('div')`
  padding-left: 28px;
`;

export {
  AuthorName,
  ReplyName,
  StyledLinkButton,
  EditLinkButton,
  FlexWrapper,
  FlexContent,
  AvatarPresenter,
  ResolveButton,
  EditIcon,
  CommentHeaderContainer,
  CommentBodyContainer,
  CommentFormContainer,
  CommentWrapper,
  CommentListContainer,
  OpeningThreadContainer,
  FlexPresenter,
  HighlightedTextContainer,
  StyledSubtext,
  HighlightedText,
  BodyContainer,
  ArticleIcon,
  IndicatorButton,
  MarkdownWrapper
};
